import * as React from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminModalDelete from "./SiteAdminModalDelete";
import { useForm, SubmitHandler } from 'react-hook-form';
import baseUrlApi from '../../lib/baseUrlApi';
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';
import { useCookies } from 'react-cookie';

type SiteAdminInputs = {
    siteId: string;
    admin: string;
    user: string;
    memo: string;
    siteRecno: number,
    setState: Function;
};

interface SiteAdminProps {
    admin: string;
    user: string;
    memo: string;
}

export default function BasicModal(prop: SiteAdminInputs) {
    const [open, setOpen] = React.useState(false);
    const [siteId, setSiteId] = useState<string>(prop.siteId);
    const [admin, setAdmin] = useState<string>(prop.admin);
    const [user, setUser] = useState<string>(prop.user);
    const [memo, setMemo] = useState<string>(prop.memo);
    const [SiteData, setSiteData] = useState<SiteAdminInputs[]>([]);
    const { register, reset, handleSubmit, formState: { errors } } = useForm<SiteAdminInputs>({
        defaultValues: {
            siteId: prop.siteId,
            admin: prop.admin,
            user: prop.user,
            memo: prop.memo,
        }
      });
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();
    const site_id = prop.siteId;
    const admin_password = prop.admin;
    const user_password = prop.user;
    const siteRecno = prop.siteRecno;
    const [error, setError] = useState<[]>([]);
    const rules = {
        required: '入力してください。',
        maxLength: {
            value: 255,
            message: "255文字以内で入力してください"
        },
        pattern: {
            value: /^[a-zA-Z0-9!@#$%^&*()_+,\.\-';:"<>?/\[\]{}|`~]+$/,
            message: "英数字のみ入力可能です"
        }
    }

    const resetData = async() => {
        console.log(".........");
        console.log(prop.siteId);
        setSiteId(prop.siteId);
        setAdmin(prop.admin);
        setUser(prop.user);
        setMemo(prop.memo);
        setError([]);
        reset();
    };

    const handleOpen = async() => {
        await resetData();
        await reset();
        setOpen(true);
    }

    const handleClose = async() => {
        await resetData();
        await reset();
        setOpen(false);
    }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit: SubmitHandler<SiteAdminInputs> = async (data) => {
        try {
            const token = cookies.access_token || "";
            let params = {
                "siteId": siteId,
                "prcKind": 1,
                "sitePass": {
                    "admin": admin,
                    "user": user
                },
                "siteRecno": siteRecno,
                "memo": memo
            };
            await ApiRequest.registSiteManage(params, token, (response: any) => {
                console.log(response);
                if (Array.isArray(response.data)) {
                    setSiteData(response.data);
                }
                setError(response.data.messsages);
                if (Array.isArray(response.data)) {
                    setSiteData(response.data);
                }
                if (response.data.result === 0) {
                    handleClose();
                }
                prop.setState(" ");
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            handleClose();
        }
    };

    return (
        <div>
            <button onClick={handleOpen} className="btn btn-blue-line"><i className="icon-edit-b"></i>編集</button>
            <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: 'flex' }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                現場情報編集
                            </div>
                            <a className="modal-close" onClick={handleClose}></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error && error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">現場ID<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input type="text"
                                            defaultValue={siteId}
                                            className={"col-320 " + (errors.siteId ? "error-disp" : "")}
                                            onChange={(e) => setSiteId(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">管理パスワード<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input type="text"
                                            defaultValue={admin}
                                            className={"col-320 " + (errors.admin ? "error-disp" : "")}
                                            onChange={(e) => setAdmin(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">閲覧パスワード<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input type="text"
                                            defaultValue={user}
                                            className={"col-320 " + (errors.admin ? "error-disp" : "")}
                                            onChange={(e) => setUser(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">メモ</div>
                                    <div className="edit-box-elm-input">
                                        <textarea
                                            defaultValue={memo}
                                            placeholder="memo"
                                            className={"col-320 " + (errors.memo ? "error-disp" : "")}
                                            onChange={(e) => setMemo(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                                <AdminModalDelete
                                    site_id={site_id}
                                    admin_password={admin_password}
                                    user_password={user_password}
                                    siteRecno={siteRecno}
                                    closeModal={handleClose}
                                    setState={prop.setState}
                                />
                            </div>
                            <div className="model-action-main">
                                <button className="btn btn-blue-line">
                                    <a onClick={handleClose} className="">
                                        キャンセル
                                    </a>
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-blue col-160">
                                        <i className="icon-check-w"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
